import theme from '../../themes/index.en'; 

const { palette, spacing, typography } = theme;

const GridStyles= {
  container: {
    padding: spacing(3),
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: spacing(2),
  }, 
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    ...typography.h4,
    marginRight: spacing(2),
    color: palette.text.primary, 
  }, 
  addButton: {
    backgroundColor: palette.primary.main,
    color: palette.common.white,
    marginLeft: spacing(2),
    '&:hover': {
      backgroundColor: `${palette.primary.main}`
    },
  }, 
  registerButton: { 
    backgroundColor: palette.secondary.main,
    color: palette.background.paper,
    px: 3,
    py: 1,  
    '&:hover': {
      backgroundColor: `${palette.secondary.main}`
    },
  }, 
  continueLaterButton: { 
    backgroundColor: palette.secondary.light,
    color: palette.background.paper,
    px: 3,
    py: 1, 
    '&:hover': {
      backgroundColor: `${palette.secondary.light}`
    }, 
  }, 
  saveButton: {
    backgroundColor: palette.primary.main,
    color: palette.common.white,
    marginLeft: spacing(2),
    marginRight: spacing(2),
    '&:hover': {
      backgroundColor: `${palette.primary.main}`
    },
  }, 
  addIcon: {
    backgroundColor: palette.secondary.main,
    color: palette.common.white,
    marginTop: spacing(3),
    '&:hover': {
      backgroundColor: `${palette.secondary.main}`
    },
  },
  filterContainer: {
    display: 'flex',
    gap: '10px',
    marginBottom: '20px',
  },  
  editIcon: {
    color: palette.secondary.main,
    marginRight: spacing(1),
    cursor: 'pointer',
    fontSize: 14,
  },
  fileIcon: {
    color: palette.success.main,
    marginRight: spacing(1),
    cursor: 'pointer',
    fontSize: 20,
  },
  viewIcon: {
    color: palette.success.dark,
    marginRight: spacing(1),
    cursor: 'pointer',
    fontSize: 20,
  },
  priceIcon: {
    color: palette.text.primary,
    marginRight: spacing(1),
    cursor: 'pointer',
    fontSize: 20,
  },
  deleteIcon: {
    color: palette.error.main,
    marginRight: spacing(1),
    cursor: 'pointer',
    fontSize: 20, 
  },
  addButtonContainer: {
    marginLeft: 'auto', 
    display: 'flex',
    alignItems: 'center',
  },
  iconStyle: { 
    marginRight: '8px',
  },
  downloadButtonContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  filterButtonContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  downloadButton: {
    backgroundColor: palette.success.main,
    color: palette.common.white, 
    marginLeft: spacing(1),
    '&:hover': {
      backgroundColor: `${palette.success.dark}`
    },
  },
  filterButton: {
    backgroundColor: palette.action.disabledBackground,
    color: palette.common.white, 
    marginLeft: spacing(1),
    '&:hover': {
      backgroundColor: `${palette.action.disabled}`
    },
  },
  importButtonContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  importButton: {
    backgroundColor: palette.warning.main,
    color: palette.common.white,
    marginLeft: spacing(1), 
    '&:hover': {
      backgroundColor: `${palette.warning.dark}`
    },
  },
};

export default GridStyles;
